// https://git.hubteam.com/HubSpot/customer-data-objects/blob/374051480a2dd5e563e0f0bf5a645517f362b162/static/js/constants/ObjectTypeIds.ts#L55
export const CONTACT_TYPE_ID = '0-1';
export const ContactProperties = {
  REGISTERED_MEMBER: 'hs_registered_member',
  LIST_MEMBERSHIP_ID: 'hs_crm_search.ilsListIds'
};
export const RegisteredMemberEnums = {
  UNREGISTERED: '0',
  REGISTERED: '1'
};